import { render } from "./ValidationError.vue?vue&type=template&id=46339c0c"
import script from "./ValidationError.vue?vue&type=script&lang=js"
export * from "./ValidationError.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.10.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__